import { AdminContext } from "@admin/admin.provider.tsx";
import { useContext } from "react";

export const useAdminContext = () => useContext(AdminContext);
